import { useCampaignPickerSorting } from '../../hooks/useCampaignPickerSorting';
import { CampaignSorting } from '../CampaignSorting/CampaignSorting';
import styles from './CampaignSortComponent.module.scss';

export const CampaignSortComponent = () => {
    const { sortGetter, setSort } = useCampaignPickerSorting();

    return (
        <div className={styles['container']}>
            <CampaignSorting sort={sortGetter()} onSort={setSort} />
        </div>
    );
};
